import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import HOME from "@/view/Home/home.vue"
//导入pinia
// import { useNewpageData } from "../stroe/pinia";

// 定义PC端路由数组
const routes: Array<any> = [
    //全匹配
    {
        path: "/",
        // 重定向
        redirect: "/Login"
    },
    //登录页
    {
        path: "/Login",
        component: () => import('@/view/Login/Login.vue')
    },
    //首页
    {
        path: "/Homepage",
        component: HOME,
        redirect: "/onhome",
        children: [
            {
                path: '/onhome',
                component: () => import('@/view/onhome/onhome.vue')
            },
        ]
    },
    //通知列表
    {
        path: "/notice",
        component: HOME,
        redirect: "/noticepage",
        children: [
            {
                path: '/noticepage',
                component: () => import('@/view/Notice/notice.vue')
            },
        ]
    },
    //修改密码
    {
        path: "/changepass",
        component: HOME,
        redirect: "/changepasspage",
        children: [
            {
                path: '/changepasspage',
                component: () => import('@/view/ChangePassword/ChangePassword.vue')
            },
        ]
    },
    //营业信息验证
    {
        path: "/verify",
        component: HOME,
        redirect: "/verifypage",
        children: [
            {
                path: '/verifypage',
                component: () => import('@/view/verify/verify.vue')
            },
        ]
    },
    //订单详情
    {
        path: "/Order",
        component: HOME,
        redirect: "/Orderlist",
        children: [
            {
                path: '/Orderlist',
                component: () => import('@/view/Orderlist/Orderlist.vue'),

            },
            {
                path: '/Orderlistviewer',
                component: () => import('@/view/Orderlist/viewer.vue'),
            },
            {
                path: '/Ordershoplist',
                component: () => import('@/view/Orderlist/shoplist.vue'),
            },
            {
                path: '/Ordershoplist',
                component: () => import('@/view/Orderlist/shoplist.vue'),
            },
            {

                path: '/Ordershipping',
                component: () => import('@/view/Orderlist/shipping.vue'),
            },
            // Returnlist
            {
                path: '/ReturnOrders',
                component: () => import('@/view/ReturnOrders/ReturnOrders.vue')
            },
            {
                path: '/Returnlist',
                component: () => import('@/view/ReturnOrders/Returnlist.vue')
            },
        ]
    },
    //商品详情
    {
        path: "/Listpage",
        component: HOME,
        redirect: "/Listproducts",
        children: [
            {
                path: '/Listproducts',
                component: () => import('@/view/Listproducts/Listproducts.vue')
            },
            {
                path: '/Listproductsdetail',
                component: () => import('@/view/Listproducts/Listproductsdetail.vue')

            },
            {
                path: '/Listproductsedit',
                component: () => import('@/view/Listproducts/edit.vue')
            },
            {
                path: '/Listproductadd',
                component: () => import('@/view/Listproducts/add.vue')
            },

            {
                path: '/Listcategories',
                component: () => import('@/view/Listcategories/Listcategories.vue')
            },
            {
                path: '/Listcategoriesdetail',
                component: () => import('@/view/Listcategories/Listcategoriesdetail.vue')
            },
            {
                path: '/Listcategoriesadd',
                component: () => import('@/view/Listcategories/Listcategoriesadd.vue')
            },
                {
                path: '/inventory-list',
                component: () => import('@/view/Financial_management/InventoryList.vue')

            },
            // 退货列表 product return
             {
                path: '/productreturn-list',
                component: () => import('@/view/Listcategories/productreturnlist.vue')

            },
            //退货添加
            {
                path: '/productreturn-add',
                component: () => import('@/view/Listcategories/productreturnadd.vue')

            },
            //退货详情修改
            {
                path: '/productreturn-detail',
                component: () => import('@/view/Listcategories/productreturndetil.vue')

            },
        ]
    },
    //财务管理
    {
        path: "/Finance",
        component: HOME,
        redirect: "/financial_management",
        children: [
            {
                path: '/financial_management',
                component: () => import('@/view/Financial_management/Financial_management.vue')
            },
            {
                path: '/financial_detail',
                component: () => import('@/view/Financial_management/financial_detail.vue')
            },
        
            {
                path: '/inventory-add',
                component: () => import('@/view/Financial_management/InventoryAdd.vue')
            },
            {
                path: '/Inventor-detail',
                component: () => import('@/view/Financial_management/Inventordetail.vue')
            },
        ]
    },
    //数据统计
    {
        path: "/Statistics",
        component: HOME,
        redirect: "/Orderstatistics",
        children: [
            {
                path: '/Orderstatistics',
                component: () => import('@/view/Statistics/Orderstatistics.vue')
            },
            {
                path: '/Usertongji',
                component: () => import('@/view/Statistics/tongji.vue')
            }
        ]
    },
    //系统设置
    {
        path: "/Systemsettings",
        component: HOME,
        redirect: "/Harvestaddress",
        children: [
            {
                path: '/Harvestaddress',
                component: () => import('@/view/System/addresslist.vue')
            },
            {
                path: '/Addressedit',
                component: () => import('@/view/System/addresslistedit.vue')
            },
            {
                path: '/AccountForm',
                component: () => import('@/view/System/AccountForm.vue')
            },
        ]
    },
]

// 添加全局守卫

// 创建一个路由实例对象
const router = createRouter({
    history: createWebHistory(),
    routes: routes
})

// 导出创建好的实例对象
export default router
